import React from 'react'

import FormAdd from "../../../../gd-form/form/form-add/form-add"
import FormManager from '../../../../gd-form/common/form-manager'
import FormError from '../../../../gd-form/common/form-error/form-error'
import Input from '../../../../gd-form/form-element/input/input'
import CopyOption from '../copy-project/copy-options/copy-option'
import CopySubtaskItem from './subtasks/subtask-item'
import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll'
import SelectParentNew from "../../../../gd-ui/select-parent-new/select-parent-new"
import {EntityType} from "../../../../gd/const/item"
import {SelectParent_RenderType} from "../../../../gd-ui/select-parent-new/@const"
import {Copy_Manager} from "../../model/manager"
import {ModalCopy_CopyOption} from "../../@types"
import {CopyTask_Manager} from "../../model/copy-task-manager"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"

// @ts-ignore
import SelectUser from '../../../../gd-ui/select-user/select-user'
// @ts-ignore
import RadioGroup from "../../../../gd-components/gd-radio-group/gd-radio-group"

export enum ModalCopy_Task_CopyOptionId {
    DESCRIPTION     = 'description',
    TAGS            = 'tags',
    NOTES           = 'notes',
    CUSTOM_FIELDS   = 'customFields',
    USERS           = 'users',
}

type Props = {
    manager : Copy_Manager
}

export default function ModalCopy_Task(props: Props) {

    const manager = props.manager as CopyTask_Manager
    const taskToCopy = manager.taskToCopy!

    const onSubmit = (result: any) => {
        if (result.copyOptions.includes(ModalCopy_Task_CopyOptionId.USERS)) {
            manager.validateUsers(result)
        } else {
            manager.commitCopy(result)
        }
    }

    const copyOptions: ModalCopy_CopyOption[] = [
        {id: ModalCopy_Task_CopyOptionId.DESCRIPTION,    title: "Task description"},
        {id: ModalCopy_Task_CopyOptionId.TAGS,           title: "Tags"},
        {id: ModalCopy_Task_CopyOptionId.NOTES,          title: "Notes"},
        {id: ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS,  title: "Custom field values"},
        {id: ModalCopy_Task_CopyOptionId.USERS,          title: "Users"},
    ]

    const parentProject = taskToCopy.parentId

    const initFormData = {
        title           : taskToCopy.title + " - copy",
        parentProject   : parentProject,
        user            : taskToCopy.actionRequiredUserId,
        copyOptions     : [
            ModalCopy_Task_CopyOptionId.DESCRIPTION,
            ModalCopy_Task_CopyOptionId.TAGS,
            ModalCopy_Task_CopyOptionId.NOTES,
            ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS,
        ]
    }

    const formStructure = {
        isFormChanged: true,
        fields: {
            title: {
                type: 'select',
                isRequired: true,
            },
            parentProject: {
                type: 'select',
                isRequired: true,
            },
            user: {
                type: 'select',
                isRequired: false,
            },
            copyOptions: {
                type: 'select',
                isRequired: false,
            }
        },
        onSubmit: onSubmit
    };

    const form = new FormManager(formStructure,initFormData);

    const onCopyAsChange = (value: any) => {
        manager.copyAsSubtask = value === 'subtask'
        manager.reRender()
    }

    const onParentSelected = (projectId: ID) => {
        form.setFieldValue("parentProject", projectId)
    }

    const onCopyOptionSelect = (id: ID) => {
        let newSelectedOptions = form.getValue('copyOptions')
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,id)
        form.setValue('copyOptions', newSelectedOptions)
    }

    const onCopySubtasksSelect = () => {
        let newSelectedOptions = form.getValue('copyOptions')
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,"copySubtasks")
        form.setValue('copyOptions', newSelectedOptions)
    }

    const projectId = form.getValue('parentProject')

    // not sure why so complicated, navernoe gde to mi peredaetm eto a gde to net ? po idee nado vobche ot task samogo brat' imho
    let isTemplate = projectId ? gd.session.projects.get(projectId)?.isTemplate : false

    const usersOptions = gd.session.companyUsers.filterByCompany(gd.companyId).exportToOptions()

    const selectedOptions = form.getValue('copyOptions')

    const copyAsOptions = [
        {
            label   : 'Subtask',
            value   : 'subtask'
        },
        {
            label   : 'Task',
            value   : 'task'
        },
    ]

    const showCopyAs    = !!taskToCopy.parentTaskId
    const showProject   = !isTemplate && !manager.copyAsSubtask
    const showSubtasks  = manager.subTasks.length > 0

    return (
         <div className="flex-column-top-stretch flex-1 min-h-0">
             <FormAdd className  = "flex-row-left-top flex-1"
                      style      = {{height: 'calc(100% - 50px - 90px)'}}
                      form       = {form}
                      showSubmit = {false}>
                 <VScroll>
                     <div className="tbl">
                         {showCopyAs &&
                             <div className="row">
                                 <div className="label p-b-40">Copy as</div>
                                 <div className="element">
                                     <RadioGroup value       = {manager.copyAsSubtask ? 'subtask' : 'task'}
                                                 items       = {copyAsOptions}
                                                 onChange    = {onCopyAsChange}/>
                                 </div>
                             </div>}

                         <div className="row">
                             <div className="label">Task title</div>
                             <div className="element">
                                 <Input size="big" form={form} name="title"/>
                                 <FormError form={form} name="title" />
                             </div>
                         </div>

                         {showProject &&
                             <div className="row">
                                 <div className="label">Project</div>
                                 <div className="element">
                                     <SelectParentNew projectId  = {projectId}
                                                      parentsFor = {EntityType.TASK}
                                                      renderType = {SelectParent_RenderType.FORM}
                                                      canBeNull  = {gd.spaces.projects.enabled}
                                                      onChange   = {onParentSelected}/>
                                     <FormError form={form} name="parentProject"/>
                                 </div>
                             </div>}

                         {!isTemplate &&
                             <div className="row">
                                 <div className="label">User</div>
                                 <div className="element">
                                     <SelectUser value           = {form.getValue('user')}
                                                 options         = {usersOptions.map((uo: any)=>uo.value)}
                                                 renderValue     = "form"
                                                 allowEmptyValue = {true}
                                                 canHaveNoValue  = {true}
                                                 noValueLabel    = "Not assigned"
                                                 placeholder     = "Not assigned"
                                                 form            = {form}
                                                 name            = "user" />
                                     <FormError form={form} name="user" />
                                 </div>
                             </div>}

                         <div className="row">
                             <div className="label">Copy</div>
                             <div className="element">
                                 {copyOptions.map(o=>
                                     <CopyOption key         = {o.id}
                                                 id          = {o.id}
                                                 title       = {o.title}
                                                 selected    = {selectedOptions.includes(o.id)}
                                                 onSelect    = {onCopyOptionSelect}/>)}
                             </div>
                         </div>

                         {showSubtasks &&
                             <div className="row">
                                 <div className="label">Subtasks</div>
                                 <div className="element">
                                     <CopyOption id          = "copySubtasks"
                                                 title       = "Copy subtasks"
                                                 selected    = {selectedOptions.includes("copySubtasks")}
                                                 onSelect    = {onCopySubtasksSelect}/>

                                     <div className="subtasks-list">
                                         {_.map(manager.subTasks, (subtask: any)=>
                                             <CopySubtaskItem key            = {subtask.id}
                                                              task           = {subtask}
                                                              usersOptions   = {usersOptions.map((u: any)=>u.value)}/>
                                         )}
                                     </div>
                                 </div>
                             </div>}
                     </div>
                 </VScroll>
             </FormAdd>

             <Modal_Submit type      = {ButtonType.PRIMARY}
                           label     = "Copy"
                           onSubmit  = {()=>{form.onSubmitClick()}}/>
         </div>

    )
}
